import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-debounce',
  templateUrl: './debounce.component.html',
  styleUrls: ['./debounce.component.less']
})
export class DebounceComponent implements OnInit {


  @Input() placeholder: string;
  @Input() delay = 500;
  @Input() cssClass: string;
  @Output() value: EventEmitter<string> = new EventEmitter();

  @Input() inputValue: string;

  constructor(private elementRef: ElementRef) {
    const eventStream = Observable.fromEvent(elementRef.nativeElement, 'keyup')
      .map(() => this.inputValue)
      .debounceTime(this.delay)
      .distinctUntilChanged();

    eventStream.subscribe(input => this.value.emit(input));
  }

  ngOnInit(): void {

  }


}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/debounce/debounce.component.ts